import { render, staticRenderFns } from "./BaseDeletedCheckBox.vue?vue&type=template&id=a2716640&scoped=true"
import script from "./BaseDeletedCheckBox.vue?vue&type=script&lang=js"
export * from "./BaseDeletedCheckBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2716640",
  null
  
)

export default component.exports